export enum FormFields {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  Role = 'role',
  Properties = 'properties',
  ExcludeFromReports = 'excludeFromReports',
}

export const FormFieldsList = [
  FormFields.Email,
  FormFields.FirstName,
  FormFields.LastName,
  FormFields.Role,
  FormFields.Properties,
  FormFields.ExcludeFromReports,
];
